export function clampRange(value, { min, max }) {
    if (isNaN(value)) {
        return min;
    }
    if (value > max) {
        return max;
    }
    else if (value < min) {
        return min;
    }
    else {
        return value;
    }
}
export function roundToHundredths(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
}
export function roundToThousandths(num) {
    return Math.round((num + Number.EPSILON) * 1000) / 1000;
}
export function stringToNumber(value) {
    if (value === "") {
        return undefined;
    }
    const number = Number(value);
    if (isNaN(number)) {
        return undefined;
    }
    return number;
}
